import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { ReportDocument, ReportDocumentTemplate } from '../../../api/app-types/report-document.app';
import { ASSIGNMENT_API } from '../../../api/services/assignment.service';
import { REPORT_API } from '../../../api/services/report.service';
import { PaginatedResponse } from '../../pagination/paginated-response';

export const documentTemplatesResolver: ResolveFn<PaginatedResponse<ReportDocumentTemplate>> = async (
	route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(REPORT_API);
	const assignmentApi = inject(ASSIGNMENT_API);
	const response = await assignmentApi.single(route.params['id'], route.params['assignmentId']);
	if (!response.data?.typeOfCareId)
		throw new Error('Cannot load report document templates: Assignment has no typeOfCareId');
	const typeOfCareFilter = response.data.isAdditionalAssignment ? undefined : response.data.typeOfCareId;
	const res = await api.getDocumentTemplates(
		typeOfCareFilter,
		undefined,
		undefined,
		response.data.isAdditionalAssignment,
	);
	return res;
};

export const reportsOfAssignmentResolver: ResolveFn<PaginatedResponse<ReportDocument>> = async (
	route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(REPORT_API);
	const res = await api.getDocumentsOfAssignment(route.params['assignmentId']);
	return res;
};

export const assignmentHasUnfinishedReportsResolver: ResolveFn<boolean> = async (
	route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(REPORT_API);
	const res = await api.getDocumentsOfAssignment(route.params['assignmentId']);
	return res.entities.some((doc) => !doc.isFinal);
};

export const reportOfAssignment: ResolveFn<ReportDocument | undefined> = async (
	route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(REPORT_API);
	const reportId = route.params['reportId'];
	const assignmentId = route.params['assignmentId'];
	if (Number.isNaN(Number(reportId))) return;
	const res = await api.getReportOfAssignment(assignmentId, Number(reportId));
	return res;
};
